<template>
  <div class="">
    <label for="donor-name">{{ label }}</label>
    <input class="form__text" type="text" id="donor-name" v-model="name" :placeholder="placeholder" />
  </div>
</template>

<script>
export default {
  name: 'DonorInfo',

  props: {
    label: { type: String, default: 'ชื่อผู้บริจาค' },
    placeholder: { type: String, default: 'เว้นว่างไว้ หากไม่ประสงค์ออกนาม' },
    value: {type: String, default: ''}
  },

  data () {
    return {
      name: this.value
    }
  },

  watch: {
    name: function (newValue, oldValue) {
      this.$emit('input', newValue)
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// DonorInfo.vue?2ceb58f6